import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { LoadingSpinner } from '@spins-gcp/shared-components-react';
import PowerBiPage from '../components/power-bi/power-bi-page';
import { PowerBiProvider } from '../components/power-bi/power-bi-provider';
import { useApplications } from '../hooks/useApplications';
import { PENDO_KEYS_BY_SLUG } from '../pendo.config';

export function AppPage() {
  const { slug } = useParams();
  const location = useLocation();
  const { apps, loading } = useApplications();

  if (loading) {
    return <LoadingSpinner />;
  }

  const app = apps.find((candidate) => candidate.slug === slug);

  if (!app) {
    // Preserve the query string: mimic params (?mimicUser=&mimicCompany=) ride on it
    return <Navigate to={{ pathname: '/', search: location.search }} replace />;
  }

  return (
    <PowerBiProvider
      appName={app.name}
      pendoApiKey={PENDO_KEYS_BY_SLUG[app.slug]}
    >
      <PowerBiPage title={app.viewKey}>
        <div data-testid="pbi-embed-container"></div>
      </PowerBiPage>
    </PowerBiProvider>
  );
}

export default AppPage;
